import StudentView from './student'

const StudentReportingView = StudentView.extend({
    reporting: true,
})

export default StudentReportingView